import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FlexV2 as Flex } from 'Shared/ui/Flex';
import { randomizer } from 'Utils';
import ArrowRight from 'crehana-icons/ArrowRight';
import ArrowLeft from 'crehana-icons/ArrowLeft';

const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const FadeIn = styled.div`
  animation: ${fadeInAnimation} 0.25s ease-in forwards;
`;

const BottomSection = styled.div`
  position: absolute;
  z-index: 10;
  bottom: 0;
  height: 24px;
  width: 100%;

  .text-center {
    text-align: center;
  }
`;

const PaginationWrapper = styled(Flex)`
  padding-bottom: 0;
`;

const Circle = styled.div`
  border-radius: 50%;
  cursor: pointer;
  border: 1px solid #fff;
  opacity: 0.5;

  background-color: ${props =>
    props.selected ? 'rgba(0,0,0,0.5) !important' : 'transparent !important'};

  height: 12px;
  margin: 0 8px;
  width: 12px;
`;

const Arrow = styled.div`
  position: absolute;
  top: calc(50% - 26px);
  padding: 8px 12px;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  & > svg {
    filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.2));
  }
`;

const Left = styled(Arrow)`
  left: 0;
  transform: translateX(-100%);
`;

const Right = styled(Arrow)`
  right: 0;
  transform: translateX(100%);
`;

class Dots extends React.Component {
  state = {
    currentSlide: 0,
  };

  componentDidMount() {
    // Make sure that the event listener is limited only to the fragment of html we want to apply.
    // If we have more than 2 sliders in one page, the event after.lory.slide will be triggered accross the document,
    // to prevent this, apply the slider.addEventListener, where slider is the fragment of html we want to apply
    const slider = document.querySelector('.js_slider');

    slider.addEventListener('after.lory.slide', this.afterChange);
  }

  afterChange = ({ detail: { currentSlide } }) => {
    this.setState({ currentSlide });
  };

  goTo = i => () => {
    const {
      headerInstance: { sliderInstance },
    } = this.props;

    sliderInstance.slideTo(i);
  };

  render() {
    const {
      length,
      headerInstance: { sliderInstance },
    } = this.props;
    const { currentSlide } = this.state;

    return (
      <FadeIn>
        <BottomSection>
          <PaginationWrapper jc="center">
            {Array.from({ length }).map((child, i) => (
              <Circle
                key={randomizer.getString()}
                selected={currentSlide === i}
                onClick={this.goTo(i)}
              />
            ))}
          </PaginationWrapper>
        </BottomSection>
        {currentSlide > 0 && (
          <Left
            onClick={() => sliderInstance.prev()}
            className="lory-arrow-left"
          >
            <ArrowLeft color="#fdfdfd" size={32} />
          </Left>
        )}
        {currentSlide < length - 1 && (
          <Right
            onClick={() => sliderInstance.next()}
            className="lory-arrow-right"
          >
            <ArrowRight color="#fdfdfd" size={32} />
          </Right>
        )}
      </FadeIn>
    );
  }
}

export default Dots;
